import { render, staticRenderFns } from "./EditCommentAnnotation.vue?vue&type=template&id=412227e0&"
import script from "./EditCommentAnnotation.vue?vue&type=script&lang=js&"
export * from "./EditCommentAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports